import { HeartFilledIcon } from "@radix-ui/react-icons";
import React, { useContext } from "react";
import { BusinessContext } from "../contexts/BusinessContext";
import { formatPhoneNumber } from "../utils/formatPhoneNumber";

function Footer() {
  const { business } = useContext(BusinessContext);
  return (
    <footer className="pt-8 bg-[#f6f6f6] text-gray-800 font-medium py-4 md:py-8 px-4 w-full z-10">
      <div className="container mx-auto flex flex-wrap items-center justify-center text-center md:text-left md:justify-start">
        <div>{business?.company_name}</div>
        <div className="ml-5">{business?.email}</div>
        <div className="ml-5">{formatPhoneNumber(business?.phone_number)}</div>
      </div>
      <div className="container mx-auto flex flex-wrap justify-between items-center">
        <div className="w-full md:w-auto text-center md:text-left">
          <p>
            Made with{" "}
            <HeartFilledIcon className="inline-block align-middle text-red-500" />{" "}
            in Austin TX. &copy; 2024 ~
            <br className="block md:hidden" />{" "}
            {/* Ensure break appears only on mobile */}
            Powered by{" "}
            <a href="https://www.octavio.co" className="hover:text-gray-600">
              Octavio, Inc
            </a>
          </p>
        </div>
        <div className="w-full md:w-auto text-center md:text-right">
          <ul className="flex justify-center md:justify-end">
            <li className="mx-3">
              <a
                href="https://www.octavio.co/terms"
                className="hover:text-gray-600"
              >
                Terms and Conditions
              </a>
            </li>
            <li className="mx-3">
              <a
                href="https://www.octavio.co/privacy"
                className="hover:text-gray-600"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
